import {
  PAGE_LICENSE_PLATES,
  PAGE_DRIVERS,
  PAGE_ORDERS,
  PAGE_PAYMENT,
  PAGE_PROFILE,
  PAGE_STATS,
  PAGE_COUPON,
  PAGE_POINTS,
  useAppContext,
} from 'use-app';
import get from 'lodash/get';
import {
  AccountIcon,
  DriverIcon,
  LicensePlateIcon,
  WalletIcon,
  StatsIcon,
  CouponIcon,
  PointCircleIcon,
  DownloadIcon,
} from 'icons';

const defaultItems = [
  {
    key: PAGE_PROFILE,
    value: '企業帳號',
    icon: <AccountIcon />,
  },
  {
    key: PAGE_DRIVERS,
    value: '駕駛帳號',
    icon: <DriverIcon />,
  },
  {
    key: PAGE_LICENSE_PLATES,
    value: '付款車牌',
    icon: <LicensePlateIcon />,
  },
  {
    key: PAGE_PAYMENT,
    value: '預存金帳戶',
    icon: <WalletIcon />,
  },
  {
    key: PAGE_POINTS,
    value: '企業紅利',
    icon: <PointCircleIcon />,
  },
  {
    key: PAGE_COUPON,
    value: '企業優惠',
    icon: <CouponIcon />,
  },
  {
    key: PAGE_STATS,
    value: '消費統計',
    icon: <StatsIcon />,
  },
  {
    key: PAGE_ORDERS,
    value: '匯出明細',
    icon: <DownloadIcon />,
  },
];

export const useLeftBar = () => {
  const { state: appState } = useAppContext();

  const generateInitState = () => {
    const me = get(appState, 'me', null);

    // me api 正在讀取中，還不知道側邊欄選項要顯示哪些
    if (me === null) {
      return [];
    }

    const { subAccount } = me;

    // 不是 sub account 就是主帳號
    if (subAccount == null) {
      return defaultItems;
    } else {
      const { vehicleIdentityRead, walletRead, orderRead, enterpriseDriverRead } = subAccount;

      // Do not show coupon page while the user is sub account
      const disallowPermissionPicker = [PAGE_COUPON];

      if (!vehicleIdentityRead) {
        disallowPermissionPicker.push(PAGE_LICENSE_PLATES);
      }
      if (!walletRead) {
        disallowPermissionPicker.push(PAGE_PAYMENT);
        disallowPermissionPicker.push(PAGE_POINTS);
      }
      if (!orderRead) {
        disallowPermissionPicker.push(PAGE_ORDERS);
      }

      if (!enterpriseDriverRead) {
        disallowPermissionPicker.push(PAGE_DRIVERS);
      }

      return defaultItems.filter(x => !disallowPermissionPicker.includes(x.key));
    }
  };

  const state = {
    items: generateInitState(),
    username: get(appState, 'me.username', ''),
    subAccountName: get(appState, 'me.subAccount.username', ''),
  };

  return { state };
};
